import { render, staticRenderFns } from "./RewardInfo.vue?vue&type=template&id=3ccbab2f"
import script from "./RewardInfo.vue?vue&type=script&lang=js"
export * from "./RewardInfo.vue?vue&type=script&lang=js"
import style0 from "./RewardInfo.vue?vue&type=style&index=0&id=3ccbab2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports